// extracted by mini-css-extract-plugin
export var alignLeft = "inlineImage-module--alignLeft--JahbL";
export var alignRight = "inlineImage-module--alignRight--tToOP";
export var sbShowMain = "inlineImage-module--sb-show-main--eHLXe";
export var wrapper = "inlineImage-module--wrapper--A7YCM";